import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Icon, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import typo from "../../../constants/dictionaries";
import Select from '../../Common/Select'
import Button from '../../../components/Buttons'
import DonViXCPModal from './DVCPModal'
import { FastField } from "formik";
import ValidatedText from "../../Common/ValidatedText";
import helper from '../../../helper/helper'
import Input from '../../Common/Input'
import Api from '../../../api';
import message from "../../Messages";


let timeout;
let currentValue;

function fetch(value, callback, user) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  if (value === "null") {
    callback([]);
  } else {
    function fake() {
      new Api().Get_DonViXinCapPheps_paged({ token: user.access_token, page: 0, size: 0, strSearch: currentValue })
        .then(res => {
          if (currentValue === value) {
            callback(res && res.data);
          }
        })
        .catch((err) => message.error(err.message))
    }
    timeout = setTimeout(fake, 800);
  }
}
class DoanhNghiep extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      setModal: false,
      data: [],
      timeout: null
    }
  }
  componentDidUpdate = (prevProps) => {
    const { values, mode } = this.props
   
    if (mode === "edit") {
      if (values.doanhNghiep_Id) {
        if (values.doanhNghiep_Id !== prevProps.values.doanhNghiep_Id) {
          this.getDVXCP(values.doanhNghiep_Ten)
        }
      }
    }
  };
  componentDidMount = () => {
    const { values, mode } = this.props
    if (mode === "edit") {
      if (values.doanhNghiep_Id) {
        this.getDVXCP(values.doanhNghiep_Ten)
      }
    }
  }

  getDVXCP = (strSearch) => {
    const { user } = this.props
    new Api().Get_DonViXinCapPheps_paged({ token: user.access_token, page: 0, size: 0, strSearch: strSearch })
      .then(res => {
      
        this.setState({ data: res && res.data })
      })
      .catch((err) => message.error(err.message))
  }
  SelectSearch = value => {
    const { user } = this.props;
    if (value && value !== "" && value !== undefined) {
      fetch(
        value,
        res => this.setState({ data: res }),
        user
      );
    } else {
      fetch(
        "null",
        res => this.setState({ data: res }),
        user
      );
    }
  };
  render() {
    const { setModal, data } = this.state;
    const { values, setFieldValue, handleGP, view, nameDoanhNghiep, nameDiaChi } = this.props
    return (
      <Row>
        <Row type="flex">
          <Col span={view === 'view' ? 24 : 21}>
            <Select placeholder={nameDoanhNghiep ? nameDoanhNghiep : typo.cscore_license_organization_placeholder}
              width="100%"
              label={nameDoanhNghiep ? nameDoanhNghiep : typo.cscore_license_organization}
              name="ten"
              name_value="id"
              defaultValue={values.doanhNghiep_Id}
              key={values.doanhNghiep_Id}
              onSearch={this.SelectSearch}
              onSelect={(value, e) => {
                setFieldValue("doanhNghiep_Id", value);
                setFieldValue("doanhNghiep_Ten", e.props.children);
                setFieldValue("doanhNghiep_DiaChi", helper.getFieldValueFromID(value, data, "diaChi"));
                handleGP(value)
              }}
              showArrow={false}
              filterOption={false}
              defaultActiveFirstOption={false}
              notFoundContent={null}
              dataSource={data}
              // disabled={mode === "edit" ? true : false}
            />
          </Col>
          <Col span={view === 'view' ? 0 : 3}>
            <Row type="flex" align="bottom" style={{ height: "100%", float: "right" }}>
              <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                <Icon style={{ color: '#fff' }} type="plus" />
              </Button>
            </Row>
          </Col>
        </Row>
        <FastField
          name="doanhNghiep_DiaChi"
          render={({ field }) => <Input label={nameDiaChi ? nameDiaChi : typo.cscore_diaChiDonViXCP} id="doanhNghiep_DiaChi"  {...field} mandatory={false} />}
        />

        <DonViXCPModal
          handleCancel={() => this.setState({ setModal: false })}
          nameDoanhNghiep={nameDoanhNghiep}
          nameDiaChi={nameDiaChi}
          handleOk={() => {
            this.setState({ setModal: false });
          }}
          isOpen={setModal} />
      </Row>
    )
  };
}
DoanhNghiep.propTypes = {
  handleGP: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(DoanhNghiep);

